export default __webpack_public_path__ + "static/media/ProspectsIcon.aa80c15f.svg";